/* eslint-disable no-use-before-define */
import React from 'react'
import { ajax, Status, isEmpty, arrayFrom, publish } from '../../../twd'
import { getAuth } from '../use-bitvore'
import useMarketNews from '../use-market-news'
import { startOfYear, addDays, startOfDay, format } from 'date-fns'

const NO_RESULT = 'There are no results that match your search. Please review your search criteria and try again'
const TIMED_OUT = 'Timed-out'

export default ({modal}) => {
    const [rows, setRows] = React.useState([])
    const [status, setStatus] = React.useState(Status.LOADING)
    const [error, setError] = React.useState('')

    const {
        tab,
        customSearchType,
        customKeyword,
        customCusip,
        customPurpose,
        customState,
        customCounty,
        customCity,
        customDate,
        holdings,
        holdingDate,
    } = useMarketNews()

    const [page, setPage]  = React.useState(1)
    const [total, setTotal] = React.useState(0)

    const timerId = React.useRef()
    const lastAbort = React.useRef()

    React.useEffect(() => {
        setPage(1)
        setTotal(0)
        setRows([])
    }, [
        tab,
        customSearchType,
        customKeyword,
        customCusip,
        customPurpose,
        customState,
        customCounty,
        customCity,
        customDate,
        holdings,
        holdingDate,
    ])

    const [params, setParams] = React.useState()
    React.useEffect(() => {
        let p = getParams({
            modal,
            page,
            tab,
            customSearchType,
            customKeyword,
            customCusip,
            customPurpose,
            customState,
            customCounty,
            customCity,
            customDate,

            holdings,
            holdingDate,
        })
        setParams(p)
    }, [
        page,
        tab,
        customSearchType,
        customKeyword,
        customCusip,
        customPurpose,
        customState,
        customCounty,
        customCity,
        customDate,
        holdings,
        holdingDate,
    ])

    React.useEffect(() => {
        if (timerId.current) {
            clearInterval(timerId.current)
            timerId.current = 0
        }

        timerId.current = setTimeout(async () => {
            setRows([])
            setError('')
            setStatus(Status.LOADING)

            if (!params) {
                setRows([])
                setStatus(Status.LOADED)
                return
            }
            let isTimedOut
            try {
                let auth = await getAuth()
                if (!auth) {
                    setStatus(Status.UNAVAILABLE)
                    return
                }

                if (lastAbort.current) {
                    lastAbort.current()
                }

                let {data, abort, isTimedOut:isTO} = await ajax({
                    url: 'https://api.bitvore.com/muninews',
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': '*/*',
                        ...auth,
                    },
                    params
                })
                isTimedOut = isTO
                lastAbort.current = abort
                let {response, total} = await data
                lastAbort.current = null

                publish('municipals-market-news-unavailable', false)

                let f = !response
                    || !Array.isArray(response)
                    || response.length===0
                if (f) {
                    setError(NO_RESULT)
                    setStatus(Status.FAILED_TO_LOAD)
                    return
                }

                setRows(response)
                setTotal(total)

                setStatus(Status.LOADED)

            } catch (e) {

                if (e.name==='SyntaxError') {
                    publish('municipals-market-news-unavailable', true)
                    return
                }

                if (e.name==='AbortError') {
                    if (isTimedOut()) {
                        setError(TIMED_OUT)
                        setStatus(Status.FAILED_TO_LOAD)
                    }
                    return
                }

                setPage(1)
                setTotal(0)
                setStatus(Status.LOADING)
            }

        }, 500)

        return () => {
            if (lastAbort.current) {
                lastAbort.current()
            }
            if (timerId.current) {
                clearInterval(timerId.current)
            }
        }
    }, [
        params
    ])

    return {
        rows, status, error,
        page, setPage,
        total
    }
}

const getParams = ({
    modal,
    page,
    tab,
    customSearchType,
    customKeyword,
    customCusip,
    customPurpose,
    customState,
    customCounty,
    customCity,
    customDate,
    holdings,
    holdingDate,
}) => {
    const pageNo = modal ? Math.max(page,1) : 1
    const pageSize = modal ? 10 : 6

    const isCustom = tab==='CUSTOM'
    const isHolding = !isCustom

    const startDate = ymd(getInitialDate(isCustom ? customDate : holdingDate))
    const endDate = ymd(new Date())
    const params = {
        startDate,
        endDate,
        timezone: 'America/New_York',
        pageNo,
        pageSize,
    }

    if (isCustom && customSearchType==='cusip' && !isEmpty(customCusip)) {
        params.cusip = arrayFrom(customCusip)
    }

    if (isCustom && customSearchType==='keyword' && !isEmpty(customKeyword)) {
        params.text= customKeyword
    }

    if (isCustom && !isEmpty(customPurpose)) {
        params.sector = customPurpose
    }

    const loc = [customCity || '', (customState || '').trim(), '']
    if (isCustom && loc.filter(Boolean).length>0) {
        params.location = [loc.join('/')]
    }

    if (isCustom && customCounty) {
        params.fips = [customCounty]
        if (!customCity) {
            delete params.location
        }
    }

    if (isHolding && !isEmpty(holdings)) {
        params.cusip = holdings.map(a => a.cusip).filter(Boolean)
    }

    if (isHolding && isEmpty(holdings)) {
        return
    }

    return params
}

const ymd = (d) => format(d, 'yyyy-MM-dd')

const getInitialDate = (dateType) => {
    let today = new Date()
    switch(dateType) {
    case "today":
        return startOfDay(today)
    case "this_month":
        return addDays(today, -29)
    case "last_90_days":
        return addDays(today, -90)
    case "this_year":
        return startOfYear(today)
    case "this_week":
    default:
        return addDays(today, -7)
    }
}



// WEBPACK FOOTER //
// ./src/municipals/market-news/news/use-news.js